import axiosInstance from './AxiosInstance';

const PartnerService = {
  createPartner: async (partnerData) => {
    try {
      const response = await axiosInstance.post('/partners', partnerData);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create partner',
        errors: error.response?.data?.errors || [],
      };
    }
  },

  updatePartner: async (id, partnerData) => {
    try {
      const response = await axiosInstance.put(`/partners/${id}`, partnerData);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update partner',
        errors: error.response?.data?.errors || [],
      };
    }
  },

  deletePartner: async (id, scope = {}) => {
    try {
      const query = new URLSearchParams();
      if (scope.companyId) query.append('companyId', scope.companyId);
      if (scope.branchId) query.append('branchId', scope.branchId);
      const url = `/partners/${id}${query.toString() ? `?${query.toString()}` : ''}`;
      const response = await axiosInstance.delete(url);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete partner',
      };
    }
  },

  getPartnerById: async (id) => {
    try {
      const response = await axiosInstance.get(`/partners/${id}`);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch partner', data: null };
    }
  },

  listPartners: async (params = {}) => {
    try {
      const q = new URLSearchParams();
      if (params.page) q.append('page', params.page);
      if (params.limit) q.append('limit', params.limit);
      if (params.search) q.append('search', params.search);
      if (params.companyId) q.append('companyId', params.companyId);
      if (params.branchId) q.append('branchId', params.branchId);
      if (params.status) q.append('status', params.status);

      const response = await axiosInstance.get(`/partners?${q.toString()}`);
      console.log('listPartners', response)
      return {
        success: response.data.success,
        data: response.data.data,
        pagination: response.data.pagination,
        message: response.data.message,
      };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Failed to list partners', data: [], pagination: {} };
    }
  },

  getPartnerDropdown: async (companyId, branchId) => {
    try {
      if (!companyId || !branchId) {
        return { success: false, message: 'companyId and branchId are required', data: [] };
      }
      const response = await axiosInstance.get(`/partners/dropdown?companyId=${companyId}&branchId=${branchId}`);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch partner dropdown', data: [] };
    }
  },
};

export default PartnerService;
